import {
  getProDescription,
  getUnauthorizedDescription,
} from '@/creditflowresearch/ui/common/components/organisms/constants';
import TileAccessFallback from '@/creditflowresearch/ui/common/components/organisms/TileAccessFallback';
import LogInButton from '@/creditflowresearch/ui/common/components/LogInButton';
import cfrUrl from '@/creditflowresearch/infrastructure/url';

import headerStyles from './TileHeader/tileHeader.module.scss';
import styles from './bondsTile.module.scss';

const tooltipContent = 'Analyze actionable securities in the US ABS secondary '
                       + 'markets on the BWIC & Inventory Monitor.';

interface ITileHeaderFallbackProps {
  isAuthorized?: boolean,
}

const TileFallback = ({
  isAuthorized = false,
}: ITileHeaderFallbackProps) => {
  const baseProps = {
    title: (
      <div className={ headerStyles.fallbackTitleContainer }>
        <span>B&I</span>
        <span>BWICS & Inventory</span>
      </div>
    ),
    dataTest: 'bondsTile',
    tooltipContent,
    className: styles.fallbackContainer,
  };
  const bondUrl = cfrUrl.getBondsInventoryABSUrl();

  if (isAuthorized) {
    return (
      <TileAccessFallback
        { ...baseProps }
        description={ (
          <div className={ styles.authDescription }>{ getProDescription(bondUrl) }</div>
        ) }
      />
    );
  }

  return (
    <TileAccessFallback
      { ...baseProps }
      description={ (
        <div className={ styles.unAuthDescription }>
          { getUnauthorizedDescription(bondUrl) }
        </div>
      ) }
      actionButton={ <LogInButton withIcon={ false } variant="outline" /> }
    />
  );
};

export default TileFallback;
